import { chevronDownOutline, chevronUpOutline, playSkipForwardOutline } from 'ionicons/icons';
import { cn } from '../../lib/utils';
import IonIcon from '../components/IonIcon';

interface Props {
  hasNext: boolean;
  onNext: () => void;
  onExpandAll: () => void;
  onCollapseAll: () => void;
  className?: string;
}

function ToolButton({
  label,
  icon,
  onClick,
  disabled,
  primary,
}: {
  label: string;
  icon: string;
  onClick: () => void;
  disabled?: boolean;
  primary?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex min-h-[40px] flex-1 items-center justify-center gap-1.5 rounded-full px-2.5 text-xs font-semibold disabled:opacity-40 ${
        primary
          ? 'bg-x9-marine text-white'
          : 'border border-x9-line bg-white text-x9-marine'
      }`}
    >
      <IonIcon icon={icon} size={16} />
      {label}
    </button>
  );
}

/** First row of the run list — sticks to the top of `.run-execute-scroll`. */
export default function RunListToolbar({
  hasNext,
  onNext,
  onExpandAll,
  onCollapseAll,
  className,
}: Props) {
  return (
    <div className={cn('run-list-toolbar -mx-4 mb-3 border-b border-x9-line px-4 py-2', className)}>
      <div className="flex items-center gap-2">
        <ToolButton
          label="Next"
          icon={playSkipForwardOutline}
          primary
          disabled={!hasNext}
          onClick={onNext}
        />
        <ToolButton
          label="Expand"
          icon={chevronDownOutline}
          onClick={onExpandAll}
        />
        <ToolButton
          label="Collapse"
          icon={chevronUpOutline}
          onClick={onCollapseAll}
        />
      </div>
    </div>
  );
}
